import React, { forwardRef, useEffect } from "react";
import { changeSecondsToString } from "../../../hooks/useCountdown";
import overrides from "./../../../../css/customization.scss";
import style from "./EndMatch.scss";
import Icon from "../../../../svgs/ActionIcon";
import Submit from "../HandleSubmit";
import { formatMatches } from "../../../utils/format-matches";
const EndConfirmationModule = forwardRef(
    (
        {
            timersPerQuarter,
            quarterSelected,
            setEndConfirmationModalOpen,
            setMatchStatus,
            matchStatus,
            matchId,
            matchData,
            setMatchData,
            setEventsToShow,
            formatApiData,
            homePlayers,
            awayPlayers,
            sides,
        },
        ref
    ) => {
        const [quarters, minutes] = formatMatches(matchData.formatObject);
        const gameInTotal = quarters * (minutes * 60);

        const quarterNumber = quarterSelected.slice(-1);
        const isNumber = /\d/.test(quarterNumber);
        const period = isNumber
            ? matchData.formatObject.periodAbbreviation + quarterNumber
            : quarterSelected;
        const allQuartersDone =
            quarters == quarterNumber || quarterSelected == "SO";

        const { matchHasShootout, homeGoals, awayGoals } = matchData;

        let modalLabel = allQuartersDone ? "End the Game?" : "End the period?";

        let totalTimePlayed = Object.values(timersPerQuarter)?.reduce(
            (acc, val) => {
                return acc + val?.timePlayed;
            },
            0
        );

        if (quarterSelected == "SO") {
            totalTimePlayed = gameInTotal;
        }

        const submitData = async () => {
            let payload = {};
            const isResultEqual = homeGoals === awayGoals;
            const isShootout =
                allQuartersDone && matchHasShootout && isResultEqual;

            let { matchPosts } = matchData;
            const shootoutObj = {
                type: "Period",
                minute: Math.ceil(totalTimePlayed / 60),
                orderIndex: matchData.matchPosts.length,
                postType: 20,
                additionalData: "Start of a shootout",
                isLive: true,
                quarter: 4,
            };

            if (!isShootout) {
                switch (quarterSelected) {
                    case "Q1":
                        payload = {
                            quarter1: true,
                            matchPosts: [
                                ...matchPosts,
                                {
                                    postType: 2,
                                    type: "Periods",
                                    orderIndex: matchPosts.length,
                                    isLive: true,
                                    minute: Math.ceil(totalTimePlayed / 60),
                                    quarterSelected: "Q1",
                                    quarter: 1,
                                },
                            ],
                        };
                        matchPosts = payload.matchPosts;
                        break;
                    case "Q2":
                        payload = {
                            quarter1: true,
                            quarter2: true,
                            matchPosts: [
                                ...matchPosts,
                                {
                                    postType: 4,
                                    type: "Periods",
                                    orderIndex: matchPosts.length,
                                    isLive: true,
                                    minute: Math.ceil(totalTimePlayed / 60),
                                    quarter: 2,
                                },
                            ],
                        };
                        matchPosts = payload.matchPosts;
                        break;
                    case "Q3":
                        payload = {
                            quarter1: true,
                            quarter2: true,
                            quarter3: true,
                            matchPosts: [
                                ...matchPosts,
                                {
                                    postType: 6,
                                    type: "Periods",
                                    orderIndex: matchPosts.length,
                                    isLive: true,
                                    minute: Math.ceil(totalTimePlayed / 60),
                                    quarter: 3,
                                },
                            ],
                        };
                        matchPosts = payload.matchPosts;
                        break;
                    case "Q4":
                        payload = {
                            quarter1: true,
                            quarter2: true,
                            quarter3: true,
                            quarter4: true,
                            matchPosts: [
                                ...matchPosts,
                                {
                                    postType: 8,
                                    type: "Periods",
                                    orderIndex: matchPosts.length,
                                    isLive: true,
                                    minute: Math.ceil(totalTimePlayed / 60),
                                    quarter: 4,
                                },
                                ...(isShootout ? [shootoutObj] : []),
                            ],
                        };
                        matchPosts = payload.matchPosts;
                        break;
                    default:
                        payload = {
                            quarter1: true,
                            quarter2: true,
                            quarter3: true,
                            quarter4: true,
                        };
                }
            }

            if (isShootout) {
                let postTypeNumber =
                    quarterNumber === 4 ? 8 : quarterNumber * 2;
                payload = {
                    quarter1: true,
                    quarter2: true,
                    quarter3: true,
                    quarter4: true,
                    ...(isShootout ? { shootout: true } : {}),
                    matchPosts: [
                        ...matchPosts,
                        {
                            postType: postTypeNumber,
                            type: "Periods",
                            orderIndex: matchPosts.length,
                            isLive: true,
                            minute: Math.ceil(totalTimePlayed / 60),
                        },
                        ...(isShootout ? [shootoutObj] : []),
                    ],
                };
            }

            //if shootout add shootout event after successful request
            if (isShootout) {
                await Submit(matchId, matchData, payload, setMatchData)
                    .then((data) =>
                        formatApiData(
                            data,
                            sides,
                            setEventsToShow,
                            ...homePlayers,
                            ...awayPlayers
                        )
                    )
                    .catch((e) => console.error(e.message));
            } else if (allQuartersDone) {
                //if endmatch add endmatch event after successful request
                const update = {
                    ...payload,
                    status: 4,
                };

                await Submit(matchId, matchData, update, setMatchData)
                    .then((data) => {
                        setMatchStatus(4);
                        formatApiData(
                            data,
                            sides,
                            setEventsToShow,
                            ...homePlayers,
                            ...awayPlayers
                        );
                    })
                    .catch((e) => console.error(e.message));
            } else {
                //end quarter event
                const newMatchPosts = matchPosts.map((post, index, arr) => {
                    if (
                        (post.postType === 26 || post.postType === 14) &&
                        index + 1 === arr.length
                    ) {
                        return {
                            ...post,
                            isDeleted: true,
                        };
                    }
                    return post;
                });
                payload = {
                    ...payload,
                    matchPosts: newMatchPosts,
                };
                await Submit(matchId, matchData, payload, setMatchData)
                    .then((data) =>
                        formatApiData(
                            data,
                            sides,
                            setEventsToShow,
                            ...homePlayers,
                            ...awayPlayers
                        )
                    )
                    .catch((e) => console.error(e.message));
            }
        };

        const endPeriodTimerHandler = async (secondsPerPeriod) => {
            const tickerStatus = 0;
            const tickerSeconds = secondsPerPeriod;
            const tickerTimestamp = Date.now();
            const update = {
                tickerTimer: true,
                dhbMatchTimers: {
                    tickerStatus,
                    tickerSeconds,
                    tickerTimestamp,
                },
            };
            await Submit(matchId, matchData, update, setMatchData);
        };

        const submitAllDataHandler = async () => {
            await submitData();
            if (!allQuartersDone) {
                await endPeriodTimerHandler(
                    timersPerQuarter[quarterSelected]?.totalTime
                );
            }
        };

        return (
            <div className={style.endMatchPopup}>
                <div
                    className={`${style["endMatch-popup__header"]} ${overrides.fontRoboto}`}
                >
                    <div>
                        <span style={{ marginRight: "5px", fontWeight: "700" }}>
                            {changeSecondsToString(
                                "totalTimePlayed",
                                totalTimePlayed
                            )}
                        </span>
                        <span style={{ color: "#6E6E6E" }}>{period}</span>
                    </div>
                    <p>{modalLabel}</p>
                </div>
                <div className={style["endMatch-popup__body"]}>
                    <Icon />
                    <button onClick={() => setEndConfirmationModalOpen(false)}>
                        No
                    </button>
                    <button
                        onClick={() => {
                            submitAllDataHandler();
                            setEndConfirmationModalOpen(false);
                        }}
                    >
                        Yes
                    </button>
                </div>
            </div>
        );
    }
);

export default EndConfirmationModule;
